<template lang="html">

  <article class="evento-el">

    <div class="contenedor-texto column-start">
      
      <nav class="tags">
        
        <router-link class="tag -white" to=""></router-link>
  
      </nav>

      <h2 class="fake--title-dato -white"></h2>

      <div class="info row-start">
        <p class="fake"></p>
        <p class="fake"></p>
      </div>

    </div>
    
  </article>

</template>

<script lang="js">
  export default  {
    name: 'evento-el',
  }
</script>

<style scoped lang="scss">


@import "@/assets/css/colors.scss";

.evento-el{
  background: $soft-black;
}

.contenedor-texto{
  background: none;
}

.tags{
  margin-bottom: 10px;
}

.tag{
  @extend .-backgroundLoad;
}

.info{
  width: 100%;
}

.info p{
  width: 100px;
  margin-right: 20px;
  font-weight: 500;
}

.info p:last-of-type{
  margin-right: 0;
}

.evento-el:nth-child(3n+3) .fake--title-dato{
  height: 50px;
}

@media screen and (max-width: 550px){
  .evento-el{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/eventos/evento-el-fake.vue